import React, { ReactElement, ReactNode } from 'react';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import { IntlShape, useIntl } from 'react-intl';
import { PersonEmailDTO } from '../../../../api/core/models';
import { getDefaultPersonEmail } from '../../../../Settings/emptyModels';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { Panel } from '../layout/Panel';
import { InputGroup } from '../layout/InputGroup';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { getVocabularyOptions } from '../../../../Vocabulary/util';

interface EmailProps {
  title: string;
  checkPermission: CheckPermissionFunction;
  emails: PersonEmailDTO[];
  onChange: (subject: PersonEmailDTO[]) => void;
  validation: ValidationResult;
  autoFocus: boolean;
}

export function Emails(props: EmailProps): ReactNode {
  const intl: IntlShape = useIntl();
  return (
    <Panel title={props.title}>
      <MultiInputControls<PersonEmailDTO>
        canEdit={props.checkPermission().canWrite}
        lines={props.emails}
        onChange={props.onChange}
        addNew={(rows: PersonEmailDTO[]): number => rows.push(getDefaultPersonEmail())}
        renderLines={(personEmail: PersonEmailDTO, onLineChange: (personEmailDTO: PersonEmailDTO) => void, actions: Actions, idx: number): ReactElement => (
          <InputGroup
            delete={{
              action: actions.delete,
              disabled: !props.checkPermission().canWrite,
            }}
          >
            <LabelledInputText
              id={`emails-${idx}-email`}
              autoFocus={props.autoFocus}
              value={personEmail.email}
              permissions={props.checkPermission('email')}
              validation={props.validation?.children[idx]?.fields?.email}
              onChange={(email: string) => onLineChange({...personEmail, email})}
              label={`${props.title}.attr.email`}

            />
            <LabelledDropdown
              id={`emails-${idx}-type`}
              value={personEmail.type}
              className={'w-15rem'}
              permissions={props.checkPermission('type')}
              validation={props.validation?.children[idx]?.fields?.type}
              options={getVocabularyOptions(intl.locale, 'email_types_list', '*')}
              onChange={(type: string): void => onLineChange({...personEmail, type})}
              label={`${props.title}.attr.type`}
            />
          </InputGroup>
        )}
      />
    </Panel>
  );
}
